module.exports = __webpack_public_path__ + "img/ebst.4c42eda0.svg";